import { StateCreator } from "zustand";
import { ProdutoDaConta, TotaisDaConta } from "../../dominio/conta.tipos";

/**
 * O pedido como o PDV o carrega em tela. Exportado porque a tela do PDV e os
 * componentes dela precisam falar desse tipo em vez de `any`.
 */
export interface DadosDoPedido {
  orderUuid?: string;
  orderCode?: string;
  orderType?: string;
  orderOwnerUuid?: string;
  orderOwnerName?: string;
  orderStatus?: number;
  createdAt?: string;
  orderManager?: string;
  // A forma do produto agora tem UM lugar só: src/dominio/conta.tipos.ts.
  // A que estava aqui exigia `productQuantity`, `people` e `productExpanded`
  // que o código nunca grava, e não citava `productCode`, `productTotalPrice`,
  // `seller` nem `productComboInfo`, que ele grava sempre.
  products?: ProdutoDaConta[];
  productsTransfer?: {
    productOrderUuid: any;
    productPrinted: boolean;
    productCode: string;
    productSelected: boolean;
    productSemiSelected?: boolean;
    productUuid: any;
    productName: any;
    productPrice: any;
    seller: string | null | undefined;
    productDiscount: string;
    productTotalPrice: number;
    productOrderedAt: string;
    peopleNumber?: string;
    productObservations?: Array<{
      observationUuid: string;
      observationName: string;
      observationPrice: number;
      observationSelected: boolean;
      productObservationProduced: boolean;
    }>;
  }[];
  totals?: Partial<TotaisDaConta> & {
    totalProductsPriceWithDiscountAndTaxes?: string;
    taxes?: string;
  };
  orderInfo?: any;
}

export interface OrderSlice {
  orderDataZustand: DadosDoPedido;

  setOrderDataZustand: (orderInfo: DadosDoPedido) => void;
}

export const createOrderSlice: StateCreator<OrderSlice> = (set: any) => ({
  orderDataZustand: {},
  setOrderDataZustand: (orderInfo) => set({ orderDataZustand: orderInfo }),
});
